module.exports = __webpack_public_path__ + "assets/img/logAudit-module1-1.5bc82250.jpg";